import { gql } from '@apollo/client'
import client from '../utils/client'
import { MutationHandlerError } from '../utils/errors'

type AddRestaurantCommunicationResult =
	| { success: true; errors: null }
	| { success: false; errors: MutationHandlerError }

const addRestaurantCommunication = async ({
	slug,
	channel,
	note,
	dueAt,
}: {
	slug: string
	channel: 'call' | 'note' | 'alarm'
	note: string
	// ISO-Zeitpunkt, nur bei Alarmen
	dueAt?: string
}): Promise<AddRestaurantCommunicationResult> => {
	try {
		const { data, errors } = await client.mutate({
			mutation: gql`
				mutation AddRestaurantCommunication(
					$slug: String!
					$channel: String!
					$note: String!
					$dueAt: String
				) {
					addRestaurantCommunication(
						slug: $slug
						channel: $channel
						note: $note
						dueAt: $dueAt
					) {
						success
						error
					}
				}
			`,
			variables: { slug, channel, note, dueAt },
			errorPolicy: 'all',
			refetchQueries: ['RestaurantCommunications', 'RestaurantAlarms'],
		})

		if (errors) return { success: false, errors }
		const result = data?.addRestaurantCommunication
		if (!result?.success) {
			return { success: false, errors: result?.error || 'Speichern fehlgeschlagen' }
		}
		return { success: true, errors: null }
	} catch (e) {
		if (e && e.networkError) return { success: false, errors: 'NETWORK_ERROR' }
		throw e
	}
}

export default addRestaurantCommunication
